import axios from 'axios';

import { JsonResponse } from 'core/models/response';
import {
	ActionMaskedShareholderResponse,
	CompanyService,
	ActionShareholderResponse,
	ServiceCost,
	ServiceKey,
	CompanySettings,
	ShareholderSharesLimit,
} from './commonModels';

export const onCheckNationalId = async (national_id: string) => {
	try {
		const response = await axios.get<JsonResponse<ActionShareholderResponse>>('dashboard/actions/check-shareholder', {
			params: { national_id },
		});
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const onCheckMaskedNationalId = async (national_id: string) => {
	try {
		const response = await axios.get<JsonResponse<ActionMaskedShareholderResponse>>('dashboard/actions/check-shareholder-masked', {
			params: { national_id },
		});
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const onGetServiceCost = async (service_key: ServiceKey) => {
	try {
		const response = await axios.get<{ success: ServiceCost }>('dashboard/actions/check-access', {
			params: { service_key },
		});
		return response.data;
	} catch (error) {}
};

export const onGetCompanyServices = async () => {
	try {
		const response = await axios.get<JsonResponse<{ services: CompanyService[] }>>('dashboard/company-services');
		return response.data.data;
	} catch (error) {}
};

export const onGetCompanySettings = async () => {
	try {
		const response = await axios.get<JsonResponse<{ settings: CompanySettings[] }>>('dashboard/company-settings');
		return response.data.data;
	} catch (error) {}
};

export const onGetShareholderSharesLimit = async (national_id: string) => {
	try {
		const response = await axios.get<JsonResponse<ShareholderSharesLimit>>('dashboard/actions/registry-transaction/shareholder-shares-limit', {
			params: { national_id },
		});
		return response.data.data;
	} catch (error) {}
};
